module.exports = __webpack_public_path__ + "static/media/NATURAL.3ada94ca.svg";